import { Layout as AntLayout } from 'antd';
import Header from '../Header';
import Footer from '../Footer';

const Layout = ({ children }: { children: React.ReactNode }) => (
  <AntLayout style={{ minHeight: '100vh' }}>
    <Header />
    <AntLayout.Content>{children}</AntLayout.Content>
    <Footer />
  </AntLayout>
);

export default Layout;
